import { TextField } from "@mui/material";
import React from "react";

export default function Input(props) {
  const {
    name,
    label,
    value,
    variant,
    onChange,
    error = null,
    required,
    ...other
  } = props;
  return (
    <TextField
      variant={variant || "filled"}
      label={label}
      name={name}
      value={value}
      onChange={onChange}
      required={required}
      {...other}
      {...(error && { error: true, helperText: error })}
    />
  );
}
